import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import RenderIf from '../../render-if/components/render-if';

import '../styles/default-select.css';

class DefaultSelect extends Component {
  render() {
    const {
      input,
      readOnlyInput,
      optionLabel,
      secondOptionLabel,
      customLabel,
      optionValue,
      labelObject,
      options,
      disabled,
      placeHolder,
      label,
      disabledOption,
      disabledValue,
      disabledText,
      className,
      errorClassName,
      inputName,
      id,
      customError,
      meta: { touched, error },
    } = this.props;

    const { t } = this.context;

    const renderOptions =
      options && options.length > 0
        ? options.map((item, index) => {
            const optLabel = item[optionLabel] ? item[optionLabel] : customLabel ? customLabel : _.get(item, secondOptionLabel);
            return (
              <option value={item[optionValue]} key={index} disabled={item[disabledOption] !== disabledValue}>
                {t(labelObject ? optLabel[labelObject] : optLabel)} {item[disabledOption] !== disabledValue && disabledText ? disabledText : ''}
              </option>
            );
          })
        : null;

    return (
      <div className={`default-select ${className ? className : ''}`}>
        <RenderIf if={label}>
          <label className="control-label" htmlFor={id || inputName}>
            {t(label || '')}
          </label>
        </RenderIf>
        <select
          readOnly={readOnlyInput}
          {...input}
          disabled={disabled}
          className={`form-control ${touched && error ? 'input-error' : ''} ${errorClassName ? errorClassName : ''}`}
          name={inputName}
          id={id || inputName}
        >
          <option value="" disabled="true">
            {t(placeHolder)}
          </option>
          {renderOptions}
        </select>
        {touched && (error || customError) && <div className="error">{t(error || customError)}</div>}
      </div>
    );
  }
}

DefaultSelect.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(state => ({
  lang: state.i18nState.lang,
}))(DefaultSelect);



// WEBPACK FOOTER //
// ./src/app/shared/default-select/components/default-select.js